// extracted by mini-css-extract-plugin
export default {"trigger":"tgKms","skeleton-progress":"K1oaq"};